export default {

	cancel: "Cancel",
	confirm: "Confirm",
  
  
	menu: {
	  about: "About Yun Cheng",
	  domainName: "Blockchain Domain",
	  login: "Login",
	  jian: "Simplified",
  
	  name: "Yun Cheng",
	  strategy: "Practical Guides",
	  case: "Success Cases",
	  insight: "Expert Insights",
	  finance: "Finance & Tech News",
	  column: "CEO Column",
  
	},
  
  
	home: {
	  slogan: "Blockchain in Hand",
	  slogan2: "Linking the Future",
	  introduction: "Yun Cheng is Hong Kong's leading blockchain and network security solution provider. We offer one-stop blockchain solutions, dedicated to helping various enterprises further develop their businesses through innovative blockchain technology, advancing from the Web 2.0 era to the new Web 3.0 era.",
  
	  roleColumn1: "Infrastructure",
	  roleroleColumn1Text1: "Blockchain as a Service (BaaS)",
	  roleroleColumn1Text2: "Private Chain, Public Chain, Hybrid Chain",
	  roleroleColumn1Text3: "RPC Node Hosting Service",
	  roleroleColumn1Text4: "Blockchain Validator & Node Hosting",
  
	  roleColumn2: "Blockchain Development",
	  roleroleColumn2Text1: "Decentralized Finance (DeFi) Solutions",
	  roleroleColumn2Text2: "GameFi Solutions",
	  roleroleColumn2Text3: "NFT Development & Marketplace Solutions",
	  roleroleColumn2Text4: "Smart Contract Development",
  
	  roleColumn3: "Blockchain Security",
	  roleroleColumn3Text1: "One-Stop Enterprise Solutions",
	  roleroleColumn3Text2: "Smart Contract Audit",
	  roleroleColumn3Text3: "Regular Security Assessments",
  
	  baasTitle: "Build Your Blockchain Ecosystem, Network, and dApps in a Reliable and Secure Environment",
	  baasSubTitle: "We have a powerful network and enterprise-grade infrastructure, allowing you to achieve your goals with minimal resource investment.",
	  baasAdvantage1: "Cross-Chain Infrastructure Support",
	  baasAdvantage2: "Support for Multiple Blockchains",
	  baasAdvantage3: "99.99% Uptime Guarantee",
	  baasAdvantage4: "Financial-Grade Network Security (Tier III Data Center)",
	  baasAdvantage5: "Low Latency",
	  baasTag1: "Private Chain, Public Chain, Hybrid Chain",
	  baasTag2: "Blockchain Node Hosting",
	  baasTag3: "RPC Node Hosting Service",
	  serviceBtnTxext: "Service Inquiry",
  
	  defiTitle: "Decentralized Finance (DeFi) Solutions",
	  defiSubTitle: "Leverage Various DeFi Solutions to Enter the Web3 Finance Industry",
	  defiDes: "Through Yun Cheng's diverse DeFi solutions utilizing blockchain and Web3 technology, we provide decentralized financial services to clients, meeting various financial needs in a faster and more efficient way.",
	  defiLi1: "Liquidity Mining, Staking Smart Contracts",
	  defiLi2: "NFT Collateral Platform, Leverage Smart Contracts",
	  defiLi3: "ICO, Cryptocurrency & NFT Launch Platforms",
	  defiLi4: "Token Swap Network, Token Cross-Chain Bridge",
	  defiLi5: "Infrastructure & Network Security",
  
	  gameTitle: "GameFi Solutions",
	  gameSubTitle: "Develop Your X-to-Earn Model and Enter the Web3 Gaming Industry",
	  gameDes: "Yun Cheng provides all blockchain technology and economic model support, allowing you to focus on game experience development.",
	  gameLi1: "Business & Economic Models",
	  gameLi2: "Game Assets",
	  gameLi3: "Game Tokens",
	  gameLi4: "NFT Marketplace",
	  gameLi5: "Infrastructure",
	  gameLi6: "Network Security",
  
	  nftTitle: "NFT Solutions",
	  nftColumn1: "NFT Marketplace",
	  nftColumn2: "Repackaged Products",
	  nftColumn3: "Membership ID",
	  nftColumn4: "Branding & Marketing Tools",
	  price: "View Pricing",
  
	  securityTitle: "Blockchain Security Solutions",
	  securitySubTitle: "24/7 Blockchain Security Services – Targeting Blockchain-Based Applications, Covering All Technical Layers",
	  securityDes: "We provide blockchain network security management services for enterprises of different scales and industries. Our blockchain and security expert team offers comprehensive security assessments for various blockchain-based applications, from design and creation to implementing blockchain security strategies and tests tailored to your business needs, preventing losses due to vulnerabilities.",
	  securityLi1: "Blockchain Security Solutions",
	  securityLi2: "Smart Contract Audit",
	  securityLi3: "Frontend Application Code Review",
	  securityLi4: "Regular Vulnerability Scanning",
	  securityLi5: "Penetration Testing",
	  securityBtnText: "Blockchain Security Solutions",
  
	  domainTitle: "Blockchain & Cryptocurrency Domains",
	  domainSubTitle: "Acquire Decentralized Identity: Register Blockchain & Cryptocurrency Domains for Your Wallet, Website, and dApps",
	  domainDes: "Use blockchain domains to simplify cryptocurrency transactions and build your decentralized website. Bind your wallet, website, and dApps with a simple, memorable domain—no more copying and pasting long addresses.",
	  domainBtnText: "Search Blockchain Domains",
  
	  paymentTitle: "Blockchain & Cryptocurrency Payment Platform",
	  paymentSubTitle: "Single Payment Platform Supporting All Electronic Payment Methods, Including Bitcoin and Other Cryptocurrencies",
	  paymentDes: "Enterprises can accept customer cryptocurrency payments via our commercial blockchain wallet and transfer to fiat currency or cold wallets. In addition to the most popular cryptocurrency—Bitcoin—we also support others like Ethereum and USDT.",
	  paymentBtnText: "View Pricing",
  
	},
  
  
	about: {
	  text: "About Yun Cheng",
	  slogan: "Blockchain in Hand, Linking the Future",
	  introduction: "Yun Cheng is Hong Kong's leading blockchain and network security solution provider. Our expert team offers consulting services and one-stop solutions for blockchain, NFT, metaverse, and cryptocurrency, dedicated to helping various enterprises further develop their businesses through innovative blockchain technology. Yun Cheng walks alongside you, advancing from Web 2.0 to the new Web 3.0 era.",
  
	  baasTitle: "Your Trusted Blockchain as a Service (BaaS) Provider",
	  baasSubTitle: "As a BaaS provider trusted by clients, Yun Cheng has a powerful network and complete infrastructure to support our clients' blockchain projects, enabling you to achieve business goals with minimal resources and investment.",
  
	  servicesTitle: "Yun Cheng Services",
	  servicesText1: "Blockchain Infrastructure",
	  servicesText2: "Blockchain Development",
	  servicesText3: "Blockchain Security",
	  servicesText4: "Cloud & Network Security Services",
  
	  advantagesTitle: "Yun Cheng Advantages",
	  advantagesItem1Title: "Attentive Service",
	  advantagesItem1SubTitle: "We Prioritize Service Quality",
	  advantagesItem1Text: "We embrace innovation. With our expertise in Web2 and Web3 technology and operations, we provide end-to-end solutions; paired with 24/7 trilingual technical support to solve problems of any scale.",
  
	  advantagesItem2Title: "Network Security",
	  advantagesItem2SubTitle: "We Protect You from Any Cyber Attacks",
	  advantagesItem2Text: "Yun Cheng's highly recognized award-winning and certified white-hat hacker team safeguards your business, providing comprehensive on-chain and off-chain protection covering consensus, network, system, user, and application layers.",
  
	  advantagesItem3Title: "Infrastructure",
	  advantagesItem3SubTitle: "We Connect to Top Data Centers to Protect Your Data Worldwide",
	  advantagesItem3Text: "We provide cloud and blockchain solutions supported by enterprise-grade infrastructure with a 99.99% uptime guarantee. With 20+ years of experience, Yun Cheng is committed to delivering high-performance, stable, and secure servers and hosting services.",
  
	  advantagesItem4Title: "Powerful Network",
	  advantagesItem4SubTitle: "We Build a Strong Network for Fastest Client Connections",
	  advantagesItem4Text: "Yun Cheng owns over 100Gb+ local bandwidth directly connected to the Hong Kong Internet Exchange (HKIX), equipped with high-quality CN2 China-Hong Kong lines, CDN, and global bandwidth for high-speed, reliable, and stable connections to Hong Kong, mainland China, and worldwide, running centralized and decentralized applications.",
  
	  teamTitle: "Our Team",
	  teamText: "Led by Yun Cheng founder and seasoned cryptocurrency investor Zhang Tao, our expert team not only masters the latest blockchain technology and cryptocurrency investment knowledge but also has rich experience in executing blockchain projects of various scales, customizing the most suitable and feasible solutions for clients transitioning from Web2 to Web3.",
	  
	  storyTitle: "Yun Cheng Brand Story",
	  story: "Founded in 1998, Yun Cheng initially focused on domain registration, web hosting, and other cloud services, gradually evolving into a cloud management, network solutions, and network security management provider. Since 2017, we have expanded into blockchain business, offering blockchain, NFT, and cryptocurrency services to clients. Our clients span Hong Kong, Taiwan, mainland China, and Greater China. Over 20 years, we have grown continuously, striving for innovation to become Hong Kong's leading tech company.",
  
	  partner: "Yun Cheng Partners",
	  customer: "Yun Cheng Clients",
  
	  it: "IT Experience",
	  kehu: "Clients Worldwide",
	  qukuaijy: "Blockchain Experience",
	  kaifa: "Developers & Engineers",
	  qukuaikf: "Blockchain Development",
	  jishuzy: "Technical Support",
	  zaixian: "Uptime Guarantee",
	  fuwuqi: "Servers in Top Data Centers",
	  hwcdn: "China & Overseas CDN Bandwidth",
	  bdcdn: "Local CDN Bandwidth",

	  
	},
  
  
	news: {
		text: "Yun Cheng",
		slogan: "Professional Articles and Insights, Revealing Everything in the Tech Field",
		latest: "Latest",
		latestDes: "Welcome to Yun Cheng! Stay tuned for our analysis articles, news updates, promotions, and press releases.",
	
		strategyDes: "Stay up-to-date with the latest trends and information on innovative technologies such as blockchain and network security.",
		caseDes: "Draw inspiration from our clients' success stories and learn how Yun Cheng walks alongside clients through this journey.",
		insightDes: "Yun Cheng blockchain and network security experts bring you unique analyses and insights.",
		financeDes: "As Hong Kong's leading blockchain and network security solution provider, KOLs closely following the latest blockchain market news bring you unique analyses and insights.",
		columnDes: "Yun Cheng's CEO, who has participated in and witnessed numerous blockchain commercial applications, shares personal analyses and views on blockchain development!",
	
	  },
	subscribe: {
	  text:"Subscribe",
	  contnet:"Get the latest blockchain, cryptocurrency, and digital asset info to stay on top of global market trends—don't miss out!",
	  email:"Email Address",
	},
  
	footer: {
	  title:"Blockchain in Hand, Linking the Future",
	  contactUs:"Contact Us",
	  payment:"Payment Methods",
	  service:"Service Agreement",
	  privacy:"Privacy Policy",
	  
	},
  
	toast: {
  
	},
  
  }